export const meetingAttachmentConstants = {
  API_BASE_PATH: 'v1/meeting_register_attachments',
  GET_MEETING_ATTACHMENTS: 'GET_MEETING_ATTACHMENTS',
  SET_MEETING_ATTACHMENTS_LOADING: 'SET_MEETING_ATTACHMENTS_LOADING',
  SET_MEETING_ATTACHMENTS_ERROR: 'SET_MEETING_ATTACHMENTS_ERROR',
};
